import { ElMessageBox } from 'element-plus'
import { isObject, isUndefined } from 'lodash-es'

type MessageType = '' | 'success' | 'warning' | 'info' | 'error'

export interface MessageBoxOptions {
  type?: MessageType
  showClose?: boolean
}

type MessageBoxAlertMethod = ((message: string, options?: MessageBoxOptions) => Promise<void>) &
  ((message: string, title: string | MessageBoxOptions, options?: MessageBoxOptions) => Promise<void>)

type MessageBoxConfirmMethod = ((message: string, options?: MessageBoxOptions) => Promise<boolean>) &
  ((message: string, title: string | MessageBoxOptions, options?: MessageBoxOptions) => Promise<boolean>)

interface MessageBox {
  alert: MessageBoxAlertMethod
  confirm: MessageBoxConfirmMethod
}

const messagebox = {
  alert: async (message: string, title?: string | MessageBoxOptions, options?: MessageBoxOptions) => {
    let titleOrOpts = ''
    if (isObject(title)) {
      options = title as MessageBoxOptions
      titleOrOpts = ''
    } else if (isUndefined(title)) {
      titleOrOpts = ''
    } else {
      titleOrOpts = title as string
    }

    try {
      await ElMessageBox.alert(message, titleOrOpts, { ...options, draggable: true })
      return
    } catch (e) {
      return
    }
  },
  confirm: async (message: string, title?: string | MessageBoxOptions, options?: MessageBoxOptions) => {
    let titleOrOpts = ''
    if (isObject(title)) {
      options = title as MessageBoxOptions
      titleOrOpts = ''
    } else if (isUndefined(title)) {
      titleOrOpts = ''
    } else {
      titleOrOpts = title as string
    }

    try {
      await ElMessageBox.confirm(message, titleOrOpts, { ...options, draggable: true })
      return true
    } catch (e) {
      return false
    }
  },
}

export const OMessageBox = messagebox as MessageBox
